export default {
	props: {
		config: Object,
	},
	computed: {
		urlSignIn(){
			if( !this.config )
				return null
			else
				return this.config.getUrl(this.clientId)
		},
		isLoaded(){	return !!this.urlSignIn;	}
	},
	data() {
		return {
		}
	},
	methods: {
	},
}